"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasDuplicateObject = exports.calculateWaitingTime = exports.FLOW_RATE_VALUES = exports.formatDurationToHMS = exports.getDurationToHMS = exports.exportCSV = exports.exportPNG = exports.removeUndefined = exports.areObjectsEqual = exports.isObjectEmpty = exports.isObject = exports.clone = exports.zip = exports.isDefined = exports.isTimestampValid = exports.isPasswordValid = exports.PASSWORD_POLICY = exports.isPhoneInternational = exports.isEmailValid = exports.isIDValid = exports.isHourValid = exports.isDayValid = exports.without = exports.uniqueBy = exports.pluck = exports.identity = exports.equals = exports.prop = exports.flattenDeep = exports.mergeDeep = exports.inEnum = void 0;
var domToImage = __importStar(require("dom-to-image"));
var downloadjs_1 = __importDefault(require("downloadjs"));
var dayjs_1 = __importDefault(require("dayjs"));
var durationPlugin = __importStar(require("dayjs/plugin/duration"));
var lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
var lodash_range_1 = __importDefault(require("lodash.range"));
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var time_1 = require("./time");
dayjs_1.default.extend(durationPlugin.default);
var inEnum = function (enu, value) { return Object.values(enu).includes(value); };
exports.inEnum = inEnum;
var mergeDeepWithPath = function (target, source, allowNullPaths) {
    var src = __assign({}, source);
    Object.keys(src).forEach(function (k) {
        var key = k;
        var isValueObject = src[key] !== null && typeof src[key] === "object" && !Array.isArray(src[key]);
        var isNullable = !!(allowNullPaths && allowNullPaths.find(function (a) { return a[0] === key; }));
        if (target[key] !== undefined) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            src[key] = isValueObject
                ? __assign({}, mergeDeepWithPath(target[key], src[key], allowNullPaths && allowNullPaths.length > 1 && allowNullPaths.map(function (_a) {
                    var _b = __read(_a), _ = _b[0], next = _b.slice(1);
                    return next;
                }))) : isNullable
                ? target[key] !== undefined
                    ? target[key]
                    : src[key]
                : target[key] != undefined
                    ? target[key]
                    : src[key];
        }
    });
    return src;
};
var mergeDeep = function (target, source, allowNullPaths) {
    return mergeDeepWithPath(target, source, allowNullPaths && allowNullPaths.map(function (a) { return a.split("."); }));
};
exports.mergeDeep = mergeDeep;
var flattenDeep = function (arr) { return arr.reduce(function (flat, toFlatten) { return flat.concat(Array.isArray(toFlatten) ? (0, exports.flattenDeep)(toFlatten) : toFlatten); }, []); };
exports.flattenDeep = flattenDeep;
var prop = function (key) {
    return function (obj) {
        return obj === null || obj === void 0 ? void 0 : obj[key];
    };
};
exports.prop = prop;
var equals = function (a) {
    return function (b) {
        return a === b;
    };
};
exports.equals = equals;
var equalProps = function (key, comparee) {
    return function (obj) {
        return (obj === null || obj === void 0 ? void 0 : obj[key]) === comparee;
    };
};
var identity = function (value) { return value; };
exports.identity = identity;
var pluck = function (o, propertyNames) { return propertyNames.map(function (n) { return o[n]; }); };
exports.pluck = pluck;
// Removes duplicates from 1st array according to the equality between the props
var uniqueBy = function (prop, array1, array2) { return array1.filter(function (el1) { return !array2.some(equalProps(prop, el1)); }); };
exports.uniqueBy = uniqueBy;
var without = function () {
    var removeFrom = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        removeFrom[_i] = arguments[_i];
    }
    return function (initialList) {
        return initialList.filter(function (el) { return !removeFrom.includes(el); });
    };
};
exports.without = without;
var isDayValid = function (dayNumber) { return dayNumber >= 0 && dayNumber <= 6; };
exports.isDayValid = isDayValid;
var isHourValid = function (hourNumber) { return hourNumber >= 0 && hourNumber < 24; };
exports.isHourValid = isHourValid;
var isIDValid = function (id, allowNegative) { return !(!allowNegative && id <= 0); };
exports.isIDValid = isIDValid;
var isEmailValid = function (email) {
    return !!email.match(/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i);
};
exports.isEmailValid = isEmailValid;
var isPhoneInternational = function (phone) { return !!phone.match(/^(?:[+]?\(?\d{2,3}\)?)?[-\s.]?\d{3}[-\s.]?\d{4,6}$/im); };
exports.isPhoneInternational = isPhoneInternational;
exports.PASSWORD_POLICY = /^(?=.*\d)(?=.*[a-z])(?=.*[\W_]).{8,}$/i;
var isPasswordValid = function (pwd) { return !!(pwd === null || pwd === void 0 ? void 0 : pwd.match(exports.PASSWORD_POLICY)); };
exports.isPasswordValid = isPasswordValid;
var MIN_TIMESTAMP_ALLOWED = 1;
var MAX_TIMESTAMP_ALLOWED = 1893456000000;
var isTimestampValid = function (ts, capped) { return ts > 0 && (!capped || (ts >= MIN_TIMESTAMP_ALLOWED && ts <= MAX_TIMESTAMP_ALLOWED)); };
exports.isTimestampValid = isTimestampValid;
function isDefined(val) {
    return val != null;
}
exports.isDefined = isDefined;
var zip = function () {
    var arrays = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arrays[_i] = arguments[_i];
    }
    var n = arrays.reduce(function (acc, cur) { return Math.max(acc, cur.length); }, 0);
    return Array.from(Array(n)).map(function (_, i) { return arrays.map(function (arr) { return (isDefined(arr[i]) ? arr[i] : undefined); }); });
};
exports.zip = zip;
var clone = function (obj) { return (0, lodash_clonedeep_1.default)(obj); };
exports.clone = clone;
var isObject = function (value) { return value !== null && typeof value === "object"; };
exports.isObject = isObject;
var isObjectEmpty = function (object) { return !object || Object.keys(object).length === 0; };
exports.isObjectEmpty = isObjectEmpty;
var areObjectsEqual = function (object1, object2) { return (0, lodash_isequal_1.default)(object1, object2); };
exports.areObjectsEqual = areObjectsEqual;
var removeUndefined = function (object) {
    if (object) {
        Object.keys(object).forEach(function (key) {
            if (object[key] === undefined) {
                delete object[key];
            }
            else if (typeof object[key] === "object") {
                object[key] = (0, exports.removeUndefined)(object[key]);
            }
        });
    }
    return object;
};
exports.removeUndefined = removeUndefined;
/**
 * Prints node Element to image, removes elements with no excluded className
 * @param node node to export
 * @param name filename
 * @param excludedClassName classnames to hide from print area
 */
var getImageDownload = function (node, name, excludedClassName) {
    if (excludedClassName === void 0) { excludedClassName = "no-export"; }
    return __awaiter(void 0, void 0, void 0, function () {
        var filter;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    filter = function (node) {
                        var className = node === null || node === void 0 ? void 0 : node.className;
                        return typeof className === "string" ? !className.includes(excludedClassName) : true;
                    };
                    return [4 /*yield*/, domToImage
                            .toPng(node, { filter: filter })
                            .then(function (dataUrl) {
                            (0, downloadjs_1.default)(dataUrl, "chart_".concat(name, "_").concat((0, dayjs_1.default)().format(time_1.EXPORT_FILE_DATE_FORMAT), ".png"));
                        })
                            .catch(function (error) {
                            console.error("Error", error);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
};
var exportPNG = function (node, name, document) { return __awaiter(void 0, void 0, void 0, function () {
    var nodeToExport;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(typeof node === "string")) return [3 /*break*/, 2];
                nodeToExport = document.getElementById(node);
                if (!isDefined(nodeToExport))
                    return [2 /*return*/];
                return [4 /*yield*/, getImageDownload(nodeToExport, name)];
            case 1:
                _a.sent();
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, getImageDownload(node, name)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.exportPNG = exportPNG;
var formatToExcelData = function (json, columnDelimiter, lineDelimiter, csvStart) {
    var _a = __read(json, 1), firstEntry = _a[0];
    var keys = Object.keys(firstEntry);
    var header = keys.join(columnDelimiter) + lineDelimiter;
    return (csvStart +
        header +
        json.map(function (item) { return keys.reduce(function (acc, curr, index) { return acc + (index >= keys.length - 1 ? "".concat(item[curr], " ") : "".concat(item[curr]).concat(columnDelimiter, " ")); }, "") + lineDelimiter; }).join(""));
};
var exportCSV = function (json, fileName, document, columnDelimiter, lineDelimiter) {
    if (columnDelimiter === void 0) { columnDelimiter = ","; }
    if (lineDelimiter === void 0) { lineDelimiter = "\n"; }
    if (!isDefined(json) || !json.length) {
        return;
    }
    var csvStart = "data:text/csv;charset=utf-8,";
    var csv = formatToExcelData(json, columnDelimiter, lineDelimiter, csvStart);
    var encodedUri = encodeURI(csv);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "".concat(fileName, "_").concat((0, dayjs_1.default)().format(time_1.EXPORT_FILE_DATE_FORMAT)));
    document.body.appendChild(link);
    link.click();
    link.remove();
};
exports.exportCSV = exportCSV;
var getDurationToHMS = function (value, unit) {
    if (unit === void 0) { unit = "seconds"; }
    var duration = dayjs_1.default.duration(value, unit);
    var daysToHours = duration.days() * time_1.DAY_IN_HOURS;
    var weekToHours = duration.weeks() * time_1.WEEK_IN_HOURS;
    var monthsToHours = duration.months() * time_1.MONTH_IN_HOURS;
    var yearsToHours = duration.years() * time_1.YEAR_IN_HOURS;
    return {
        hours: duration.hours() + daysToHours + weekToHours + monthsToHours + yearsToHours,
        minutes: duration.minutes(),
        seconds: duration.seconds(),
    };
};
exports.getDurationToHMS = getDurationToHMS;
var formatDurationToHMS = function (value, unit) {
    if (unit === void 0) { unit = "seconds"; }
    var _a = (0, exports.getDurationToHMS)(value, unit), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
    return [hours && "".concat(hours, "h"), minutes && "".concat(minutes, "m"), seconds && "".concat(seconds, "s")].filter(Boolean).join(" ");
};
exports.formatDurationToHMS = formatDurationToHMS;
exports.FLOW_RATE_VALUES = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read((0, lodash_range_1.default)(1, 30, 1)), false), __read((0, lodash_range_1.default)(30, 60, 5)), false), __read((0, lodash_range_1.default)(60, 120, 10)), false), __read((0, lodash_range_1.default)(120, 601, 30)), false);
var calculateWaitingTime = function (inside, flowRate) { return inside.map(function (item) { return item * flowRate; }); };
exports.calculateWaitingTime = calculateWaitingTime;
var hasDuplicateObject = function (array, property) {
    var seen = new Set();
    return array.some(function (obj) { return seen.size === seen.add(obj[property]).size; });
};
exports.hasDuplicateObject = hasDuplicateObject;
